
import http from '@/assets/api/http';

// 获取小运力公司列表
export async function getSmallTransportList(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.smallTransportList', params, 'POST');
}

// 新增小运力公司
export async function editSmallTransport(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.editSmallTransport', params, 'POST');
}

// 获取小运力公司详情
export async function getSmallTransportDetail(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.smallTransportDetail', params, 'POST');
}

// 修改对账日
export async function updateBillsCheckDate(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateReconciliationDay', params, 'POST');
}

// 修改分润比例
export async function updatePlatShareRatio(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateProfitRatio', params, 'POST');
}

// 修改分润比例
export async function updateRiderRatio(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateRiderRatio', params, 'POST');
}

// 修改基本信息
export async function updateBaseInfo(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateSmallTransportBasicInfo', params, 'POST');
}

// 修改银行账户信息
export async function updateBankAccountInfo(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateSmallTransportBankInfo', params, 'POST');
}

// 开通/关闭区域运营
export async function updateTransportZoneOperation(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateTransportZoneOperation', params, 'POST');
}

// 小运力运营区域列表
export async function getTransportAreaList(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.listTransportZone', params, 'POST');
}

// 新建小运力运营区域
export async function addTransportArea(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.addTransportZone', params, 'POST');
}

// 修改小运力运营区域
export async function updateTransportArea(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.editTransportZone', params, 'POST');
}

// 小运力运营区域上下线
export async function updateTransportAreaStatus(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.switchTransportZoneStatus', params, 'POST');
}

// 获取小运力运营区域详情
export async function getTransportAreaDetail(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.getTransportZone', params, 'POST');
}

// 获取小运力运营区域商户列表
export async function getTransportAreaMerchants(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.listTransportZoneMerchant', params, 'POST');
}

// 获取小运力运营区域商户计价模板
export async function getDeliveryFeeTemplate(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.getDeliveryFeeTemplate', params, 'POST');
}

// 获取小运力运营区域骑士列表
export async function getTransportAreaRiders(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.listTransportZoneRider', params, 'POST');
}

// 获取小运力运营区域分拣点列表
export async function getTransportAreaTransfers(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.listTransportZoneLink', params, 'POST');
}

// 获取小运力运营区域骑士配送费列表
export async function getTransportAreaRiderDeliveryFeeList(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.listTransportZoneRiderDeliveryFee', params, 'POST');
}

// 获取运营公司列表
export async function getOperatingCenterList(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.companyItem', params, 'POST');
}

// 修改服务商分佣比例
export async function updateServiceProviderRatio(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateServiceProviderRatio', params, 'POST');
}

// 获取运营公司省市区列表
export async function getCompanyAreas(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.OperationAreaInfoMisService.findOperationAreaInfoList', params, 'POST');
}

// 获取运营公司省市区列表
export async function updateRiderDeposit(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateRiderDeposit', params, 'POST');
}

// 更新骑手收益比例设置
export async function updateRiderRatioV2(params) {
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.updateRiderRatioV2', params, 'POST');
}